import type { MuscleId } from './muscle-map.types';

/** Every muscle the figure can draw, in head-to-toe order. */
export const MUSCLE_IDS: readonly MuscleId[] = [
  'neck',
  'traps',
  'shoulders',
  'chest',
  'biceps',
  'triceps',
  'forearms',
  'abs',
  'obliques',
  'lats',
  'lower_back',
  'glutes',
  'quads',
  'hamstrings',
  'adductors',
  'calves',
  'hips',
  'ankles',
];

/**
 * Display names. These are what the UI shows, deliberately not the API's own
 * strings — the catalogue is inconsistent about them (`Delts` vs `Deltoids`,
 * `Quads` vs `Quadriceps`), and a map that renamed a muscle depending on which
 * exercise you opened would read as a bug.
 */
export const MUSCLE_LABELS: Readonly<Record<MuscleId, string>> = {
  neck: 'Neck',
  traps: 'Trapezius',
  shoulders: 'Deltoids',
  chest: 'Chest',
  biceps: 'Biceps',
  triceps: 'Triceps',
  forearms: 'Forearms',
  abs: 'Abdominals',
  obliques: 'Obliques',
  lats: 'Lats',
  lower_back: 'Lower back',
  glutes: 'Glutes',
  quads: 'Quadriceps',
  hamstrings: 'Hamstrings',
  adductors: 'Adductors',
  calves: 'Calves',
  hips: 'Hips',
  ankles: 'Ankles',
};
